import styled from 'styled-components';

const StyledNumbersRowSingle = styled.div`
  position: relative;
  width: 83.33%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: ${ props => props.newHome ? 0 : 160}px;
  margin-left: auto;
  &.extra--margin{
    margin-bottom: ${ props => props.theme.components_spacing_desk.xxlarge}px;
  }
  @media screen and (max-width: 1023px){
    width: 100%;
    margin-bottom: ${ props => props.newHome ? 0 : 128}px;
    margin-right: auto;
    &.extra--margin{
      margin-bottom: ${ props => props.theme.components_spacing_tablet.xxlarge}px;
    }
  }
  @media screen and (max-width: 767px){
    padding: 0;
    margin-bottom: ${ props => props.newHome ? 0 : 80}px;
    flex-direction: column-reverse;
    &.extra--margin{
      margin-bottom: ${ props => props.theme.components_spacing_mobile.xxlarge}px;
    }
  }
`;

export {
  StyledNumbersRowSingle,
};

